<template>
  <div id="data-edit-tab-info">

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="Name*" v-model="data_local.name" type="text" v-validate="'required'" name="name" :maxlength="30"/>
        <span class="text-warning text-sm"  v-show="data_local.name.length == 30">You have reached your maximum limit of characters allowed.</span>
        <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>

        <!-- <div class="vx-row mt-4">
          <div class="w-full vx-col">
            <label class="vs-input--label">Text Color*</label>
          </div>
          <div class="w-5/6 vx-col">            
            <vs-input class="w-full" v-model="data_local.amenity_f_color" type="text" v-validate="'required'" name="amenity_f_color"/>
            <span class="text-danger text-sm"  v-show="errors.has('amenity_f_color')">{{ errors.first('amenity_f_color') }}</span>
          </div>

          <div class="w-1/6 vx-col">
            <vs-input class="w-full cursor-pointer h-10 rounded-lg" v-model="data_local.amenity_f_color" type="color" v-validate="'required'" name="amenity_f_color"/>
          </div>
        </div> -->

        <div class="vx-row mt-4">
          <div class="w-full vx-col">
            <label class="vs-input--label">Background Color*</label>
          </div>
          <div class="w-5/6 vx-col">            
            <vs-input class="w-full" v-model="data_local.amenity_color" type="text" v-validate="'required'" name="amenity_color"/>
            <span class="text-danger text-sm"  v-show="errors.has('amenity_color')">{{ errors.first('amenity_color') }}</span>
          </div>

          <div class="w-1/6 vx-col">
            <vs-input class="cursor-not-allowed w-full cursor-pointer h-10 rounded-lg" v-model="data_local.amenity_color" type="color" v-validate="'required'" name="amenity_color" />
          </div>
        </div>

        <div class="mt-4">
          <label class="vs-input--label">Min Time</label>
          <v-select :options="optionMinHours" :reduce="val => val.id" label="val" v-model="data_local.min_hours" name="min_hours"/>
          <span class="text-danger text-sm"  v-show="errors.has('min_hours')">{{ errors.first('min_hours') }}</span>
        </div>

        <div class="mt-4">
          <label class="vs-input--label">Max Time*</label>
          <v-select :options="optionMaxHours" :reduce="val => val.id" label="val" v-validate="'required'" v-model="data_local.max_hours" name="max_hours"/>
          <span class="text-danger text-sm"  v-show="errors.has('max_hours')">{{ errors.first('max_hours') }}</span>
        </div>

        <div class="mt-4">
          <label class="vs-input--label">Buffer Time*</label>
          <v-select :options="optionBufferTime" :reduce="val => val.id" label="val" v-validate="'required'" v-model="data_local.buffer_time" name="buffer_time"/>
          <span class="text-danger text-sm"  v-show="errors.has('buffer_time')">{{ errors.first('buffer_time') }}</span>
        </div>

        <vs-input class="w-full mt-4" label="Booking Limit" v-model="data_local.booking_limit" type="number" name="booking_limit" />
        <span class="text-danger text-sm"  v-show="errors.has('booking_limit')">{{ errors.first('booking_limit') }}</span>

        <div class="mt-4">
          <label class="vs-input--label">Booking Limit Unit</label>
          <v-select :options="optionBookingLimitUnit" :reduce="val => val.id" label="val" v-model="data_local.booking_limit_unit" name="booking_limit_unit"/>
          <span class="text-danger text-sm"  v-show="errors.has('booking_limit_unit')">{{ errors.first('booking_limit_unit') }}</span>
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <!-- Col Content -->
        <div class="vx-row ">
          <div class="vx-col w-full">            
            <vs-input class="w-full mt-4" label="Deposit" v-model="data_local.deposit_amount" type="number" name="deposit_amount" />
            <span class="text-danger text-sm"  v-show="errors.has('deposit_amount')">{{ errors.first('deposit_amount') }}</span>

            <vs-textarea height="100px" class="w-full mt-4" label="Booking Message" v-model="data_local.booking_message" type="text" name="booking_message" />        
            <span class="text-danger text-sm"  v-show="errors.has('booking_message')">{{ errors.first('booking_message') }}</span>

            <vs-textarea height="100px" class="w-full mt-4" label="Terms and Conditions" v-model="data_local.terms_conditions" type="text" name="terms_conditions" />
            <span class="text-danger text-sm"  v-show="errors.has('terms_conditions')">{{ errors.first('terms_conditions') }}</span>
          </div>
        </div>

       <!-- Col Header -->
        <div class="flex items-end md:mt-4 mt-base">
          <feather-icon icon="FolderIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Files</span>
        </div>

        <!-- Col Content -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <!-- uploading docs -->
            <div class="flex items-start flex-col sm:flex-row">
              <div v-if="files.length > 0" v-for="(item, file) in files">
                <feather-icon icon="XCircleIcon" svgClasses="h-6 w-6" style="top: 12px;left: 82px;color: #ea5455;" class="cursor-pointer" @click="deleteImage(fileKey[file], file)"/>
                <img :src="item" class="mt-4 mr-8 rounded h-24 w-24" />  
              </div>
              <p v-if="files.length ==0" class="mt-2">No files uploaded</p>
            </div>

            <div class="flex items-start flex-col sm:flex-row">
              <!-- <vs-avatar :src="data_localavatar" size="80px" class="mr-4" /> -->
              <!-- uploading docs -->
              <div class="mt-4">            
                <input type="file" multiple="multiple" id="fileD" class="hidden" ref="update_avatar_input" @change="update_avatar" accept="image/*">

                <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Upload Files</vs-button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Content Row -->
    <div class="vx-row mt-4" style="height:500px">
      <div class="vx-col w-full">      
        <div class="flex items-end md:mt-8">
          <feather-icon icon="CalendarIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Hours of Operation</span>
        </div>
        <div class="vx-row w-full mt-4">
          <div class="w-full vx-col">
            <vs-table stripe :data="optionHours" :class="{'hours-of-operation':hopErr}">
              <template slot="thead">
                <vs-th>Day</vs-th>
                <vs-th>24 Hours</vs-th>
                <vs-th>Operational Hours</vs-th>
                <vs-th></vs-th>
              </template>

              <template>
                <vs-tr v-for="(currentD, indexD) in optionOperationalDays" :key="indexD">
                  <vs-td>{{currentD.name}}</vs-td>
                  <vs-td>
                    <vs-switch vs-icon-on="check" v-model="data_local.operational_days_json[indexD]['is_all_day']" color="warning" vs-value="m-yes">
                      <span slot="off"></span>
                    </vs-switch>
                  </vs-td>
                  <vs-td>
                    <vs-chip closable @click="remove(indexD, index)" color="#24c1a0" close-icon="close" v-for="(current, index) in data_local.operational_days_json[indexD]['val']" :key="index">
                      {{current}}
                    </vs-chip>
                  </vs-td>
                  <vs-td>
                    <feather-icon icon="PlusCircleIcon" svgClasses="h-6 w-6 text-success m-auto" style="top: 5px;left: 10px;" class="cursor-pointer w-full vx-col" @click="selectPopup(indexD)"/>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>        
          </div>
        </div>       
      </div>
    </div>    
    
    <vs-popup classContent="popup-example" title="Select Operating Hours" :active.sync="popupActive2">
      <div class="vx-col w-full opHours" style="height:250px">
        <div class="vx-row mb-base" style="height:150px;">          
          <div class="mt-4 w-1/2 vx-col">
            <v-select :options="optionHour" :reduce="val => val.id" label="val" v-validate="'required'" v-model="op_start_time" name="op_start_time" class="inputx" placeholder="Start time"/>
            <span class="text-danger text-sm"  v-show="errors.has('op_start_time')">{{ errors.first('op_start_time') }}</span>
          </div>   

          <div class="mt-4 w-1/2 vx-col">
            <v-select :options="optionHour" :reduce="val => val.id" label="val" v-validate="'required'" v-model="op_end_time" name="op_end_time" class="inputx" placeholder="End time"/>
            <span class="text-danger text-sm"  v-show="errors.has('op_end_time')">{{ errors.first('op_end_time') }}</span>
          </div>   
        </div>
        <div class="mt-6">            
          <vs-button class="mr-2" @click="addNewOpHours" color="primary" type="filled" >Add New</vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from '../../../../axios'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  components: {
    vSelect,
    flatPickr
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      hopErr: false,
      opStartTimeErr: false,
      opEndTimeErr: false,
      popupActive2: false,

      configdateFromTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        minTime: "8:00",
        maxTime: "17:00",
        time_24hr: true
      },
      configdateToTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        minTime: "8:00",
        maxTime: "17:00",
        time_24hr: true
      },
      configFromdateTimePicker: {
        minDate: new Date(),
        maxDate: null,        
        "disable": [
            function(date) {
                // return true to disable
                return (date.getDay() === 0 || date.getDay() === 6);

            }
        ]
      },
      configTodateTimePicker: {
        minDate: null,
        "disable": [
            function(date) {
                // return true to disable
                return (date.getDay() === 0 || date.getDay() === 6);

            }
        ]
      },

      optionMinHours: [
        { id:1, val: 'None' },
        { id:3, val: '30 Mins' },
        { id:5, val: '1 Hour' },
        { id:6, val: '2 Hours' },
        { id:7, val: '3 Hours' }
      ],

      optionMaxHours: [
        { id:1, val: 'None' },
        { id:3, val: '30 Mins' },
        { id:5, val: '1 Hour' },
        { id:6, val: '2 Hours' },
        { id:7, val: '3 Hours' },
        { id:8, val: '4 Hours' },
        { id:9, val: '5 Hours' },
        { id:10, val: '6 Hours' },
        { id:11, val: '7 Hours' },
        { id:12, val: '8 Hours' }
      ],

      optionBufferTime: [
        { id:1, val: 'None' },
        { id:3, val: '30 Mins' },
        { id:5, val: '1 Hour' },
        { id:6, val: '2 Hours' },
        { id:7, val: '3 Hours' },
        { id:8, val: '4 Hours' }
      ],

      optionBookingLimitUnit: [
        { id:1, name: 'Daily' },
        { id:2, name: 'Weekly' },
        { id:3, name: 'Monthly' },
        { id:4, name: 'Annual' }
      ],

      optionOperationalDays: [
        { id:0, name: 'Sunday' },
        { id:1, name: 'Monday' },
        { id:2, name: 'Tuesday' },
        { id:3, name: 'Wednesday' },
        { id:4, name: 'Thursday' },
        { id:5, name: 'Friday' },
        { id:6, name: 'Saturday' }
      ],

      optionHour: [],
      optionHours: [],
      operational_days: [],
      operational_hours: [      
        { id:1, val: [], op_start_time:[], op_end_time:[], is_all_day:false },
        { id:2, val: [], op_start_time:[], op_end_time:[], is_all_day:false },
        { id:3, val: [], op_start_time:[], op_end_time:[], is_all_day:false },
        { id:4, val: [], op_start_time:[], op_end_time:[], is_all_day:false },
        { id:5, val: [], op_start_time:[], op_end_time:[], is_all_day:false },
        { id:6, val: [], op_start_time:[], op_end_time:[], is_all_day:false },
        { id:7, val: [], op_start_time:[], op_end_time:[], is_all_day:false }
      ],
      switchArray: [],
      selectedPopUpId: 0,
      op_start_time: null,
      op_end_time: null,


      files: [],
      rawFiles: [],
      resDataLocal: [],
      resUp: [],
      fileKey: [],
      filesDel: [],

      token: localStorage.usertoken,
      data_local: JSON.parse(JSON.stringify(this.data)),

      statusOptions: [
        { label: 'Active',  value: 'active' },
        { label: 'Blocked',  value: 'blocked' },
        { label: 'Deactivated',  value: 'deactivated' }
      ],
      roleOptions: [
        { label: 'Admin',  value: 'admin' },
        { label: 'User',  value: 'user' },
        { label: 'Staff',  value: 'staff' }
      ]
    }
  },
  computed: {
    status_local: {
      get () {
        return { label: this.capitalize(this.data_local.status),  value: this.data_local.status  }
      },
      set (obj) {
        this.data_local.status = obj.value
      }
    },
    role_local: {
      get () {
        return { label: this.capitalize(this.data_local.role),  value: this.data_local.role  }
      },
      set (obj) {
        this.data_local.role = obj.value
      }
    },
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    remove(x, y) {
      this.data_local.operational_days_json[x]['op_start_time'].splice(y, 1)
      this.data_local.operational_days_json[x]['op_end_time'].splice(y, 1)
      this.data_local.operational_days_json[x]['op_start_time_id'].splice(y, 1)
      this.data_local.operational_days_json[x]['op_end_time_id'].splice(y, 1)
      this.data_local.operational_days_json[x]['val'].splice(y, 1)
    },
    checkOverlap(s, e){
      let objS = this.data_local.operational_days_json[this.selectedPopUpId]['op_start_time_id']
      let objE = this.data_local.operational_days_json[this.selectedPopUpId]['op_end_time_id']
      let objC = false

      for (const [key, value] of Object.entries(objS)) {

        console.log('objS[key] ', objS[key])
        console.log('objE[key] ', objE[key])

        for (let i = objS[key]; i <= (objE[key]-1); i++) { 
          console.log('i ', i)
          console.log('i === s ', i === s)
          objC = i === s ? true : objC
        }
      }
      
      return objC
    },
    addNewOpHours() {   
      if (this.op_start_time == null || this.op_end_time == null) {
        this.opStartTimeErr = true
        this.opEndTimeErr = true
        return
      } else {
        this.opStartTimeErr = false
        this.opEndTimeErr = false

        if (this.checkOverlap(this.op_start_time, this.op_end_time)) {

          this.$vs.notify({
            color: 'danger',
            title: 'Data Saved',
            text: 'Choose different time'
          })
          return
        } 
      }

      if (this.op_start_time > this.op_end_time) {
        this.opStartTimeErr = false
        this.opEndTimeErr = false

        this.$vs.notify({
          color: 'danger',
          title: 'Data Saved',
          text: 'Start time is greater than End time'
        })    
        return    
      }

      if (this.op_start_time == this.op_end_time) {
        this.opStartTimeErr = false
        this.opEndTimeErr = false

        this.$vs.notify({
          color: 'danger',
          title: 'Data Saved',
          text: 'Start time should not be equal to End time'
        })    

        return    
      }

      this.op_start_time_id = this.op_start_time
      this.op_end_time_id = this.op_end_time

      this.optionHour.filter((res) => {
        this.op_start_time = this.op_start_time == res['id'] ? res['val'] : this.op_start_time
        this.op_end_time = this.op_end_time == res['id'] ? res['val'] : this.op_end_time
      })  

      var newOp = this.op_start_time + ' to ' + this.op_end_time
      var count = this.data_local.operational_days_json[this.selectedPopUpId]['val'].length 

      this.data_local.operational_days_json[this.selectedPopUpId]['val'][count] = newOp
      this.data_local.operational_days_json[this.selectedPopUpId]['op_start_time'][count] = this.op_start_time
      this.data_local.operational_days_json[this.selectedPopUpId]['op_end_time'][count] = this.op_end_time
      this.data_local.operational_days_json[this.selectedPopUpId]['op_start_time_id'][count] = this.op_start_time_id
      this.data_local.operational_days_json[this.selectedPopUpId]['op_end_time_id'][count] = this.op_end_time_id

      console.log('this.data_local.operational_days_json ', this.data_local.operational_days_json)

      this.popupActive2=false
      // this.onFromTimeChange(null, this.op_end_time, null)
      // this.op_start_time = this.op_end_time
      this.op_start_time = this.op_start_time_id + 1
      this.op_end_time = this.op_start_time + 1
      this.hopErr = false
    },
    selectPopup(id) {
      this.popupActive2=true
      this.selectedPopUpId = id
    },
    onFromTimeChange(selectedTime, timeStr, instance) {
      console.log('selectedTime ', selectedTime)
      console.log('timeStr ', timeStr)
      console.log('instance ', instance)

      this.$set(this.configdateFromTimePicker, 'minTime', timeStr);     
      this.$set(this.configdateToTimePicker, 'minTime', timeStr);     
    },
    onFromChange(selectedDates, dateStr, instance) {
      this.$set(this.configTodateTimePicker, 'minDate', dateStr);
    },
    onToChange(selectedDates, dateStr, instance) {
      this.$set(this.configFromdateTimePicker, 'maxDate', dateStr);
    },
    changeOptionHours() {

      // if (this.data_local.buffer_time = 1) {
        var bt = 60
        var ii = 0
        var hh = 0
        var id = 0
        var x = 0
        var xx = 0
        var yy = 0
        var zz = 0
        var zx = 0
        var tya = ''
        var tyb = ''

        for (var i = 8; i < 17; i++) {
          for (ii; ii < 60; ii=ii+bt) {
            hh = ii==0? '00':ii
            x = ii+bt
            xx = x == 60 ? '00' : x
            zz = xx == 60 ? i : i+1
            tya = i >= 12 ? 'PM' : 'AM'
            tyb = zz >= 12 ? 'PM' : 'AM'
            zx = i > 12 ? i-12 : i
            zz = zz > 12 ? zz-12 : zz
            yy = ('0' + zx).slice(-2)+':'+hh + tya + ' to ' + ('0' + zz).slice(-2)+':'+xx+ tyb
            this.optionHours.push({'id': id, 'name': yy})
            id++
          }
          ii = 0
        }

        console.log('this.optionHours ', this.optionHours)
      // }
    },
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    async loadData () {
      const editId = this.$route.params.editId
      try {    
          this.files = []
          //reading docs
          this.tableRead = await axios.post(`/docs/table/read/`, {
            token: this.token,
            path: `docs/amenity/gallery/${editId}`,
            document_folder_id: 24
          })

          //reading docs
          for (const [key, value] of Object.entries(this.tableRead.data.uploadedD)) {
            var imgB64 = this._arrayBufferToBase64( value.data.Body.data )
            var imgAsc = imgB64.toString('ascii')
            this.files.push("data:image/png;base64, " + imgAsc)
            this.fileKey.push(value.key)
          }

      } catch(err) {
        console.log(err.toString('utf8'));
      }
    },   
    deleteImage(f, k) {
      // document.getElementById(f).style.display = 'none';
      console.log('f ', f)
      console.log('k ', k)
      this.$delete(this.fileKey, k)
      this.$delete(this.files, k)
      this.$delete(this.rawFiles, k)
      this.filesDel.push(f)

      this.$vs.notify({
        color: 'success',
        title: 'Deleting Data',
        text: 'File deleted'
      })
    },
    save_changes () {
      this.hopErr = true

      this.data_local.operational_days_json.filter((res) => {
        this.hopErr = res['val'].length > 0 ? false : this.hopErr
      })  

      /* eslint-disable */
      if (!this.validateForm) return

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */

      const editId = this.$route.params.editId
      this.data_local.deposit_amount = parseFloat(this.data_local.deposit_amount).toFixed(2);
      new Promise(async(resolve, reject)  => {
        try {    
          await axios.post(`/amenity/save/${editId}`, {
              data: this.data_local,
              token: this.token
            })
            .then(res => {
              if(res['data'] != 'access_denied' && res['data'] != '') {

                if(res['data']['message'] == 'success') {
                  this.$vs.notify({
                    color: 'success',
                    title: 'Data Saved',
                    text: 'The selected data was successfully Saved'
                  })
                  // this.$router.push({name:'app-amenity-view', params: {viewId: editId }})
                } else {
                  this.$vs.notify({
                    color: 'danger',
                    title: 'Saving Data',
                    text: 'Something went wrong'
                  })
                }

              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
                // this.$router.push({name:'app-amenity-view', params: {viewId: editId }})
                this.$router.go(-1)
              }

            })
            .catch(err => {
              this.$vs.notify({
                color: 'danger',
                title: 'Data Saving Error',
                text: 'The selected data was not saved'
              })
            }) 

          // uploading docs
          await axios.post(`/docs/table/save`, {
            rawFiles: this.rawFiles,
            token: this.token,
            id: editId,
            path: `docs/amenity/gallery/${editId}`,
            folderId: 24
          })

          // delete docs
          await axios.post(`/docs/table/delete`, {
            data: this.filesDel,
            token: this.token
          })

          // this.$router.push({name:'app-amenity-list', params: {viewId: editId }})
          this.$router.go(-1)
        } catch(err) {
          reject(err.toString('utf8'));
        }      

      }) 
    },
    reset_data () {
      this.data_local = JSON.parse(JSON.stringify(this.data))
      this.$vs.notify({
        color: 'orange',
        title: 'Data Edit',
        text: 'The selected Data data was reset'
      })
    },
    //uploading docs
    _arrayBufferToBase64( buffer ) {
      var binary = '';
      var bytes = new Uint8Array( buffer );
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
          binary += String.fromCharCode( bytes[ i ] );
      }
      return window.btoa( binary );
    },
    //uploading docs
    async update_avatar () {
      this.$vs.loading()
      var formdata = new FormData();
      $.each($('#fileD')[0].files, function(i, file) {
        formdata.append('fileD_'+i, file);
      });
      formdata.append('token', this.token)

      this.resUp = await axios.post(`/docs/upload`,  
        formdata, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        }
      )

      for (const [key, value] of Object.entries(this.resUp.data.rawD)) {
        var imgB64 = this._arrayBufferToBase64( value.data.data )
        var imgAsc = imgB64.toString('ascii')
        this.files.push("data:image/png;base64, " + imgAsc)
      }

      if (this.resUp.data.uploadedD.length > 1) {
        for (const [key, value] of Object.entries(this.resUp.data.uploadedD)) {
          this.rawFiles.push(value)
        }
      } else {
        this.rawFiles[0] = this.resUp.data.uploadedD
      }

      setTimeout(() => {
        this.$vs.loading.close()
      }, 2000)
    },
    async loadAmenityTime() {
      try {    
        var res = await axios.get(`/api/amenity-time/list`, {
            headers: { 'Authorization': this.token, 'property_ref': localStorage.selectedParentOrgRef }
        })

        this.optionMinHours = res['data']
        this.optionMaxHours = res['data']
        this.optionBufferTime = res['data']       
      } catch(err) {
        reject(err.toString('utf8'));
      }  

      console.log('res optionMinHours ', this.optionMinHours)
    },  
    async loadFreq() {
      try {    
        var res = await axios.get(`/api/freq/list`, {
            headers: { 'Authorization': this.token, 'property_ref': localStorage.selectedParentOrgRef }
        })

        this.optionBookingLimitUnit = res['data']      
      } catch(err) {
        reject(err.toString('utf8'));
      }  

      console.log('res optionBookingLimitUnit ', this.optionBookingLimitUnit)
    }, 
    loadHour() {
      let id = 0
      let yy = 0
      let tya = 0
      let hh = 0
      let zx = 0
      let bt = 30
      let ii = 0

      for (let i = 0; i <= 23; i++) {
        for (ii; ii < 60; ii=ii+bt) {
          hh = ii==0? '00':ii
          tya = i >= 12 ? 'PM' : 'AM'
          zx = i > 12 ? i-12 : i
          zx = zx === 0 ? 12 : zx
          yy = ('0' + zx).slice(-2)+':'+hh + tya
          this.optionHour.push({'id': id, 'val': yy})
          id++
        }

        ii = 0
      }
    }   
  },
  created () {
    this.loadData()
    this.changeOptionHours()
    // this.loadAmenityTime()
    this.loadFreq()
    this.loadHour()
  } 
}
</script>
<style lang="scss">
  div.vs-con-input input[type=color] {
    padding: 0px !important;
    height: 2.5rem !important;
    border-radius: 5px;
  }

  div.opHours input.danger {
    border: 1px solid red;
  }

  div.am-op-st input.flatpickr-input {
    width: 100px; 
  }

  div.hours-of-operation {
    border: 1px solid red;
  }

  div.opHours ul.vs__dropdown-menu {
    height: 200px;
  }  
</style>
